import { useLanguage } from 'contexts/LanguageContext'
import React from 'react'

const flags = {
  pl: <span>PL</span>,
  en: <span>EN</span>
}

const LanguageSelect: React.FC = () => {
  const [language, setLanguage] = useLanguage()

  const toggleLanguage = () => {
    const newLanguage = language === 'pl' ? 'en' : 'pl'
    setLanguage(newLanguage)
    window.location.reload()
  }

  return (
    <div
      className='languageSelect'
      onClick={toggleLanguage}
      style={{ cursor: 'pointer', display: 'inline-block' }}>
      {flags[language]}
    </div>
  )
}

export default LanguageSelect
